import { ZhihuOutlined } from '@ant-design/icons'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { api, sendAsync } from '../../app/applicationSlice'
import { RootState, RootThunk, RootThunkApi } from '../../app/store'
import { List } from '../../models/page'
import * as S from '../../services/insurance'
import {
  getTabelListFnParams,
  saveIllnessParams,
} from '../../services/insurance'

export interface ProvincePageValue {
  begndate: string
  chrgitmLv: string
  crteOptinsNo: string
  crteTime: string
  crterId: string
  crterName: string
  enddate: string
  hilistCode: string
  hilistName: string
  hilistUseType: string
  insuAdmdvs: string
  insuranceCode: string
  listType: string
  lmtCpndType: string
  lmtUsedFlag: string
  matnUsedFlag: string
  medChrgitmType: string
  medUseFlag: string
  memo: string
  optTime: string
  opterId: string
  opterName: string
  optinsNo: string
  pinyin: string
  poolareaNo: string
  rid: string
  status: number
  tenantId: number
  updtTime: string
  valiFlag: string
  wubi: string
}

// 省目录
export const getProvincePage = createAsyncThunk<
  List<ProvincePageValue>,
  S.ProvincePageParams,
  RootThunkApi
>('/medical/getCountryPage', async (body, api) => {
  return sendAsync(S.getProvincePage(body), api)
})

export interface PaymentPageValue {
  begndate: string
  createTm: string
  crteOptinsNo: string
  crteTime: string
  crterId: string
  crterName: string
  enddate: string
  hilistCode: string
  insuAdmdvs: string
  insuranceCode: string
  optTime: string
  opterId: string
  opterName: string
  optinsNo: string
  poolareaNo: string
  rid: string
  selfpayProp: string
  selfpayPropPsnType: string
  selfpayPropType: string
  status: number
  tabname: string
  tenantId: number
  updateTm: string
  updtTime: string
  valiFlag: string
}

// 自付目录
export const getPaymentPage = createAsyncThunk<
  List<PaymentPageValue>,
  S.PaymentPageParams,
  RootThunkApi
>('/medical/getChinesePage', async (params, api) => {
  return sendAsync(S.getPaymentPage(params), api)
})

export interface LimitPriceValue {
  begndate: string
  crteOptinsNo: string
  crteTime: string
  crterId: string
  crterName: string
  enddate: string
  hilistCode: string
  hilistLmtpricType: string
  hilistPricUplmtAmt: number
  insuAdmdvs: string
  insuranceCode: string
  itemType: number
  optTime: string
  opterId: string
  opterName: string
  optinsNo: string
  overlmtDspoWay: string
  poolareaNo: string
  rid: string
  status: number
  tabname: string
  tenantId: number
  updtTime: string
  valiFlag: string
}

// 限价目录
export const getLimitPage = createAsyncThunk<
  List<LimitPriceValue>,
  S.LimitPageParams,
  RootThunkApi
>('/medical/getLimitPage', async (params, api) => {
  return sendAsync(S.getLimitPage(params), api)
})

// 目录上传
export const uploadExcelAsync = createAsyncThunk<
  void,
  S.uploadExcelParams,
  RootThunkApi
>('/commodity/uploadExcelAsync', async (body, api) => {
  return sendAsync(S.uploadExcel(body), api)
})

// 目录同步
export const syncInsuranceListAsync = createAsyncThunk<
  void,
  S.syncInsuranceListParams,
  RootThunkApi
>('/commodity/syncInsuranceListAsync', async (body, api) => {
  return sendAsync(S.syncInsuranceList(body), api)
})

// 目录变化分析
export const catalogUpdateAnalysisAsync = createAsyncThunk<
  void,
  string,
  RootThunkApi
>('/commodity/catalogUpdateAnalysisAsync', async (body, api) => {
  return sendAsync(S.catalogUpdateAnalysis(body), api)
})

export interface UploadProgressResponse {
  id: number
  updateUser: number
  taskStatus: number
  taskSum: number
  taskCnt: number
  status: number
  createUser: number
  taskMsg: string
  taskName: string
  tenantId: string
  createTime: string
  updateTime: string
}
// 上传进度
export const getUploadProgress = createAsyncThunk<
  Array<UploadProgressResponse>,
  { ids: Array<number> },
  RootThunkApi
>('/commodity/getUploadProgress', async (body, api) => {
  return sendAsync(S.uploadProgress(body), api)
})

// 医保目录-疾病设置-表格
export const getTabelList = createAsyncThunk<
  any,
  getTabelListFnParams,
  RootThunkApi
>('/commodity/getTabelList', async (params, api) => {
  return sendAsync(S.getTabelListFn(params), api)
})

// 医保目录-疾病设置-新增疾病目录
export const saveIllnessAsync = createAsyncThunk<
  any,
  saveIllnessParams,
  RootThunkApi
>('/commodity/saveIllnessAsync', async (params, api) => {
  return sendAsync(S.saveIllness(params), api)
})

